import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const streamPush: RouteRecordItem = {
  path: '/stream-push',
  name: 'StreamPush',
  component: LAYOUT,
  redirect: { name: 'StreamPushList' },
  meta: {
    orderNo: 6,
    icon: 'solar:stream-bold',
    title: t('routes.streamPush.推流列表'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'list',
      name: 'StreamPushList',
      component: () => import('@/pages/stream-push/index.vue'),
      meta: {
        title: t('routes.streamPush.推流列表'),
      },
    },
    {
      path: 'detail',
      name: 'StreamPushDetail',
      component: () => import('@/pages/stream-push/detail.vue'),
      meta: {
        title: t('routes.streamPush.推流详情'),
        currentActiveMenu: '/stream-push/list',
        hideMenu: true,
      },
    },
  ],
}

export default streamPush
